import React, { useState } from 'react';
import { Popover, IconButton } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { trackEvent } from 'src/services/analytics';
import { getCostMapping } from '@src/constants/cost';
import { segmentCaseWithNumbers } from '@src/utilities/numberFormattingUtility';
import styles from './CostPopover.module.scss';

interface Props {
	eventText: string;
	funding?: string;
	id: string;
	location: 'highlight' | 'section';
}

export const CostPopover: React.FC<Props> = ({ eventText, funding, id, location }) => {
	const [showPopover, setShowPopover] = useState(false);
	const costMapping = getCostMapping(funding);

	return (
		<Popover
			id={`${id} popover`}
			onOutsideClick={() => setShowPopover(false)}
			popoverContent={costMapping[id].content}
			show={showPopover}
			triggerRefProp='forwardRef'
		>
			<IconButton
				appearance='minimal'
				className={styles.popoverIcon}
				icon={<InfoOutlinedIcon size={16} />}
				label={costMapping[id].label}
				onClick={() => {
					setShowPopover(true);
					trackEvent('Clickable', {
						tag: `program_tuition_${location}`,
						text: segmentCaseWithNumbers(eventText),
						type: 'popover',
					});
				}}
			/>
		</Popover>
	);
};
